import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
// import Clarity from "@microsoft/clarity";
// import { PostHogProvider } from "@posthog/react";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { router } from "./routes";

import { ThemeProvider } from "./themes/ThemeProvider";
import { MyPlayerProvider } from "./context/MyPlayerContext";

// const isProd = process.env.NODE_ENV !== 'development'

// 1. Initialize PostHog
// const options = {
//   api_host: isProd ? '/ingest' : 'https://us.i.posthog.com',
//   defaults: '2025-11-30',
// }
// const postHogApiKey = isProd ? 'phc_BsbRSOw52Dg6htcCYMYocb30oIctmCMigDJlzqGZLQS' : undefined

// Microsoft Clarity
// const projectId = "v7026bccxp";
// Clarity.init(projectId);

// Initialize Google Analytics 4
import ReactGA from "react-ga4";
import { consentManager } from "./utils/consent";

const GA_MEASUREMENT_ID = "G-NQBQWSGNMS";
console.log("Initializing GA4 with ID:", GA_MEASUREMENT_ID);
ReactGA.initialize(GA_MEASUREMENT_ID, {
  // Enable test mode in development
  testMode: process.env.NODE_ENV === "development",
  debug: process.env.NODE_ENV === "development",
});
console.log("GA4 initialized, testMode:", process.env.NODE_ENV === "development");

// Initialize consent management
consentManager.initializeConsent();
console.log("Consent management initialized");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <PostHogProvider apiKey={postHogApiKey} options={options}> */}
      <ThemeProvider>
        <MyPlayerProvider>
          <RouterProvider router={router}></RouterProvider>
        </MyPlayerProvider>
      </ThemeProvider>
    {/* </PostHogProvider> */}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
